// Provider Service - GraphQL operations for Providers
import { graphqlClient } from '../graphqlClient';

// ==================== Get All Providers ====================

export const getAllProviders = async () => {
  // Try with nameEn first, fallback without it if schema doesn't support it yet
  const queryWithNameEn = `
    query GetAllProviders {
      getAllProviders {
        id
        code
        name
        nameEn
        status
        createdAt
        updatedAt
      }
    }
  `;

  const queryWithoutNameEn = `
    query GetAllProviders {
      getAllProviders {
        id
        code
        name
        status
        createdAt
        updatedAt
      }
    }
  `;
  
  try {
    const result = await graphqlClient.query(queryWithNameEn);
    console.log('Providers fetched:', result.getAllProviders);
    return result.getAllProviders || [];
  } catch (error) {
    console.warn('Query with nameEn failed, trying without:', error.message);
    try {
      const result = await graphqlClient.query(queryWithoutNameEn);
      console.log('Providers fetched (without nameEn):', result.getAllProviders);
      // Add empty nameEn field for compatibility
      return (result.getAllProviders || []).map(p => ({ ...p, nameEn: null }));
    } catch (fallbackError) {
      console.error('Error fetching providers:', fallbackError);
      throw fallbackError;
    }
  }
};

// ==================== Get Provider By ID ====================

export const getProviderById = async (id) => {
  const query = `
    query GetProviderById($id: String!) {
      getProviderById(id: $id) {
        id
        code
        name
        nameEn
        status
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query, { id });
  return result.getProviderById;
};


